module.exports = __webpack_public_path__ + "img/artExam.5867e4b2.png";